var memberApi = {

    formId: '1421',
    memberSchemaId: '498',
    globalUserId: getCookie('globalUserId') ? getCookie('globalUserId').replace(/"/g, "") : '',
    apiBaseUrl: window.smk_api_host,

    // 发送验证码
    sendCode: function(unique, action,successCallback, errorCallback){
        var params = {
            unique: unique,
            sign: common.getSendCodeSign(),
            action: action
        };

        this.api('/api/sms/code/send',params, successCallback, errorCallback);
    },

    // 登录
    login: function (unique, password, smsCode, successCallback, errorCallback) {
        var params = {
            "backUrl": getUrlPara('backUrl') || '',
            "formId": this.formId,
            "unique": unique,
            "password": password || '',
            "checkCode": smsCode,
            "loginType": baseVerif.isMobile(unique) ? "mobile" : "email",
            "url": window.location.href,
            "browseInfo": client.browseInfo,
            "globalUserId": getCookie('globalUserId') ? getCookie('globalUserId').replace(/"/g, "") : '',
            "getuserinfo": common.getUrlPara('getuserinfo') || '',
            "utm_source": common_utmObj.utm_source || '',
            "utm_medium": common_utmObj.utm_medium || '',
            "utm_campaign": common_utmObj.utm_campaign || '',
            "utm_content": common_utmObj.utm_content || '',
            "utm_term": common_utmObj.utm_term || '',
            "backUrl": common.getUrlPara('backUrl') || '',
        };
        if(common.isWx){
            params.verify = wx_auth.verify || '';
        }
        this.api((common.isM ? solution_m_host : solution_host) + '/api/account/login',params,successCallback, errorCallback);
    },

    // 忘记密码 找回密码
    forgetPassword: function(data, successCallback, errorCallback){
        data.password = data.password || '';
        this.api('/api/account/pwd/find',data,successCallback, errorCallback);
    },

    getRegisterFormDataWithId: function(id, successCallback){
        var url = '/api/account/getRegisterForm';
        if (window.location.href.indexOf('v=v') > -1){
            // 访员注册
            url = url + "?isFang=1"
        }
        this.api(url, {
            formId: id
        },  function (data) {
            // 这里处理一下字段
            var passwordIndex = -1;
            data.data.columns = data.data.columns.map(function(item, index) {
                item.placeholder = item.columnName;
                // 增加错误信息
                if (item.type === 'text'){
                    // 输入框
                    item.errorText = '请输入' + item.columnName;
                } else if (item.type === 'radio-list'){
                    // 下拉单选
                    item.errorText = '请选择' + item.columnName;
                    item.openOptions = false;
                    if (item.isRelated === 1){
                        // 级联项
                        item.childContent = null;
                        item.content = item.content.map(function (childitem) {
                            childitem.child.value = '';
                            childitem.child.errorText = '请选择' + childitem.child.name;
                            childitem.child.error = false;
                            childitem.child.placeholder = childitem.child.name;
                            childitem.child.openOptions = false;
                            childitem.child.isMust = item.isMust;
                            return childitem;
                        })
                    }
                } else if(item.type === 'radio-select' || item.type === 'checkbox'){
                    // 单选 多选
                    item.errorText = '请选择';
                }
                if (item.column === 'password' && item.isMust == 1 && item.isShow == 1){
                    passwordIndex = index;
                }
                item.error = false;
                item.value = '';
                if (item.type == 'checkbox'){
                    // checkbox 初始化为空数组
                    item.value = [];
                }
                // 一些默认填写的字段 ip、设备类型、页面来源......
                switch (item.column) {
                    case 'mediaSources': //推广来源
                        item.value = getUrlPara('mediasources') || $.cookie('mediasources') || '';
                        break;
                    case 'dellRegisterIp': // 注册ip
                        item.value = client.ip;
                        break;
                    case 'channelsources': // 渠道来源
                        item.value = getUrlPara('channelsource') || '';
                        break;
                    case 'linksourcemodule': //页面来源模块
                        item.value = getUrlPara('linksourcemodule') || '';
                        break;
                    case 'linksource': //页面来源
                        item.value = document.referrer;
                        break;
                    case 'browser': //设备浏览器
                        item.value = client.browseInfo.browser;
                        break;
                    case 'platform': // 设备系统
                        item.value = client.browseInfo.os;
                        break;
                    case 'equipment': // 设备类型
                        item.value = client.browseInfo.equipment;
                        break;
                }

                return item;
            })

            if (passwordIndex > -1){
                data.data.columns.splice(passwordIndex+1, 0, {
                    column: "password2",
                    columnName: "确认密码",
                    errorText: "请再次确认密码",
                    error: false,
                    placeholder: "请再次确认密码",
                    content: null,
                    value: '',
                    isMust: 1,
                    isShow: 1,
                    type: "text",
                    isRelated: 0
                })
            }
            successCallback(data);
        })
    },

    // 获取注册表单字段
    getRegisterFormData: function( successCallback ){
        var url = '/api/account/getRegisterForm';
        if (window.location.href.indexOf('v=v') > -1){
            // 访员注册
            url = url + "?isFang=1"
        }
        this.api(url, null,  function (data) {
            // 这里处理一下字段
            var passwordIndex = -1;
            data.data.columns = data.data.columns.map(function(item, index) {
                item.placeholder = item.columnName;
                // 增加错误信息
                if (item.type === 'text'){
                    // 输入框
                    item.errorText = '请输入' + item.columnName;
                } else if (item.type === 'radio-list'){
                    // 下拉单选
                    item.errorText = '请选择' + item.columnName;
                    item.openOptions = false;
                    if (item.isRelated === 1){
                        // 级联项
                        item.childContent = null;
                        item.content = item.content.map(function (childitem) {
                            childitem.child.value = '';
                            childitem.child.errorText = '请选择' + childitem.child.name;
                            childitem.child.error = false;
                            childitem.child.placeholder = childitem.child.name;
                            childitem.child.openOptions = false;
                            childitem.child.isMust = item.isMust;
                            return childitem;
                        })
                    }
                } else if(item.type === 'radio-select' || item.type === 'checkbox'){
                    // 单选 多选
                    item.errorText = '请选择';
                }
                if (item.column === 'password' && item.isMust == 1 && item.isShow == 1){
                    passwordIndex = index;
                }
                item.error = false;
                item.value = '';
                if (item.type == 'checkbox'){
                    // checkbox 初始化为空数组
                    item.value = [];
                }
                // 一些默认填写的字段 ip、设备类型、页面来源......
                switch (item.column) {
                    case 'mediaSources': //推广来源
                        item.value = getUrlPara('mediasources') || $.cookie('mediasources') || '';
                        break;
                    case 'dellRegisterIp': // 注册ip
                        item.value = client.ip;
                        break;
                    case 'channelsources': // 渠道来源
                        item.value = getUrlPara('channelsource') || '';
                        break;
                    case 'linksourcemodule': //页面来源模块
                        item.value = getUrlPara('linksourcemodule') || '';
                        break;
                    case 'linksource': //页面来源
                        item.value = document.referrer;
                        break;
                    case 'browser': //设备浏览器
                        item.value = client.browseInfo.browser;
                        break;
                    case 'platform': // 设备系统
                        item.value = client.browseInfo.os;
                        break;
                    case 'equipment': // 设备类型
                        item.value = client.browseInfo.equipment;
                        break;
                }

                return item;
            })

            if (passwordIndex > -1){
                data.data.columns.splice(passwordIndex+1, 0, {
                    column: "password2",
                    columnName: "确认密码",
                    errorText: "请再次确认密码",
                    error: false,
                    placeholder: "请再次确认密码",
                    content: null,
                    value: '',
                    isMust: 1,
                    isShow: 1,
                    type: "text",
                    isRelated: 0
                })
            }
            successCallback(data);
        })
    },

    // 验证手机号是否注册
    checkUnique: function(unique,successCallback){
        this.api(this.apiBaseUrl + '/member/checkUnique', {
            memberSchemaId:this.memberSchemaId,
            unique: unique,
            fieldName: baseVerif.isEmail(unique) ? 'email' : "mobile",
            globalUserId: getUserInfo.options.globalUserId,
        },successCallback)
    },

    regist: function(submitData, successCallback, errorCallback ){
        if(common.isWx){
            submitData.verify = wx_auth.verify;
        }

        // 如果使用了真实公司
        if(window.ifMatchingcompanyName && submitData.enterprise_name){
            submitData['company'] = submitData.enterprise_name;
            submitData['c_keyword'] = common.getSS('companyKey') || '';
        }

        console.log(window.ifMatchingcompanyName);
      this.api('/api/account/register', submitData,successCallback, errorCallback);
    },

    // 验证验证码是否正确
    checkSmsCode: function(unique, code, action, success, error){
        var info = {
            unique: unique,
            checkCode: code,
            formId: this.formId,
            schemaId: this.memberSchemaId,
            action: action,
            globalUserId: this.globalUserId,
        };
        this.api(this.apiBaseUrl + '/member/GetToken', info, success, error);
    },

    // 更新用户信息
    updateUserInfo: function (formData) {
        var smarketMember = JSON.parse(common.getCookie('smarketMember_498'));
        postJson(solution_host + '/api/account/updateMember',{
            "tenantId":"444",
            "schemaId":"498",
            "memberFormId":"1430",
            "session": smarketMember.session,
            "url": window.location.href,
            "browseInfo": window.client.browseInfo,
            "formData":formData,
            "globalUserId": getUserInfo.options.globalUserId
        })
    },

    // 轻注册
    registerSimple: function (submitData,successCallback, errorCallback) {
        this.api('/api/account/registerSimple', submitData,successCallback, errorCallback);
    },

    // 注册or登录
    loginOrRegister: function (submitData,successCallback, errorCallback) {
        this.api('/api/account/loginandregister', submitData,successCallback, errorCallback);
    },

    api: function (url , data, successCallback,errorCallback) {
        $.ajax({
            url: url,
            method: 'POST',
            data: data,
            success:function (res) {
                if (successCallback && typeof successCallback == 'function'){
                    successCallback(res);
                }
            },
            error: function (error) {
                console.log('请求超时，请重试', url);
                if (errorCallback  && typeof errorCallback == 'function'){
                    errorCallback()
                }
            }
        })
    }


}
